import React from 'react';

const Tutorial = ({ onBack }) => {
  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '40px 20px', fontFamily: 'sans-serif' }}>
      <h2 style={{ color: '#3742fa', textAlign: 'center' }}>📖 วิธีการเล่น (How to Play)</h2>
      
      <div style={{ backgroundColor: '#f1f2f6', padding: '20px', borderRadius: '12px', marginBottom: '20px', lineHeight: '1.6' }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#ff4757' }}>1. เป้าหมายของคุณ</h4>
        <p style={{ margin: 0 }}>ทำยอดขายอาหารให้ถึงเป้าหมายก่อนที่พลังงาน (AP) จะหมด</p>
      </div>

      <div style={{ backgroundColor: '#f1f2f6', padding: '20px', borderRadius: '12px', marginBottom: '20px', lineHeight: '1.6' }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#ff4757' }}>2. การปรุงอาหาร (Crafting)</h4>
        <p style={{ margin: 0 }}>คลิกเลือกวัตถุดิบ 1-3 ชิ้นบนมือ จากนั้นกดปุ่มแผงเครื่องมือด้านล่าง (เช่น สับ, โขลก, ต้ม) การลงมือทำ 1 ครั้ง จะเสีย 1 AP เสมอ</p>
      </div>

      <div style={{ backgroundColor: '#f1f2f6', padding: '20px', borderRadius: '12px', marginBottom: '20px', lineHeight: '1.6' }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#ff4757' }}>3. การเสิร์ฟ และ ตลาดสด</h4>
        <p style={{ margin: 0 }}>เมื่อได้เมนูอาหารสำเร็จรูป ให้กด "เสิร์ฟ" เพื่อรับเงิน เมื่อผ่านด่าน คุณจะเข้าสู่ตลาดสดเพื่อนำเงินไปซื้อวัตถุดิบเข้ากองการ์ด (Deck) หรือซื้ออุปกรณ์ก้นครัวเพื่อรับบัฟพิเศษ</p>
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button 
          onClick={onBack}
          style={{ padding: '12px 30px', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#2f3542', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
        >
          กลับสู่หน้าหลัก
        </button>
      </div>
    </div>
  );
};

export default Tutorial;